import { render, staticRenderFns } from "./Contactsupport.vue?vue&type=template&id=647a1a78&"
import script from "./Contactsupport.vue?vue&type=script&setup=true&lang=js&"
export * from "./Contactsupport.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports